<div
  *ngIf="inquiry"
  class="container-fluid"
>
  <div class="row">
    <div class="col-full-12">
      <div
        class="sticky-content-container"
        baseIsSticky
      >
        <base-go-back-teaser
          [qualificationName]="inquiry.mainQualification?.name || ''"
          [dateFrom]="inquiry.dateFrom!"
          [dateTo]="inquiry.dateTo!"
        ></base-go-back-teaser>
        <base-customer-inquiry-offers-list-filters
          [branches]="branches"
          [qualifications]="mainQualifications"
          [filtersForm]="filtersForm"
        ></base-customer-inquiry-offers-list-filters>
        <div class="d-flex justify-content-between mt-3 me-3">
          <base-search
            class="me-3"
            placeholder="search.forCandidates"
            [value]="activatedRoute.snapshot.queryParams.search"
            [useEnterEvent]="true"
            (query)="onSearchChange($event)"
          ></base-search>
          <div class="d-flex">
            <div>
              <ng-container [ngTemplateOutlet]="footerTemplate"></ng-container>
            </div>
            <base-button
              label="inquiry.showInquiryInfo"
              color="primary"
              class="d-flex align-items-center mt-2 mt-sm-0 gap-2 ms-xs-4 ms-sm-0 ms-md-4"
              (btnClick)="toggleSidebar()"
            ></base-button>
          </div>
        </div>
      </div>
      <div class="row">
        <base-infinite-scroll
          *ngIf="offers.length > 0"
          (scrollDownEvent)="onScrollDown()"
        >
          <div class="listview container-fluid">
            <div class="listview-header">
              <div class="row">
                <div class="col-3">
                  <base-sortable-headline-item
                    orderKey="profileLastName"
                    [label]="('name' | translate) + ' | ' + ('readiness' | translate)"
                  ></base-sortable-headline-item>
                </div>
                <div class="col-3">
                  <div baseTruncate>{{ 'provider' | translate }}</div>
                </div>
                <div class="col-2">
                  <base-sortable-headline-item
                    label="qualifications.singular"
                    orderKey="qualificationName"
                  ></base-sortable-headline-item>
                </div>
                <div class="col-1">
                  <base-sortable-headline-item
                    label="price.singular"
                    orderKey="price"
                  ></base-sortable-headline-item>
                </div>
                <div class="col-1">
                  <div baseTruncate>{{ 'shiftStatus.legend.available' | translate }}</div>
                </div>
                <div class="col-2"></div>
              </div>
            </div>

            <ng-container *ngIf="!!inquiry.directlyInquired && !!filteredOffers.length && !hasDirectlyInquiredOffers">
              <base-empty-list-row
                message="inquiry.directlyInquiredWasNotOffered"
                [hideBackgroundImage]="true"
              ></base-empty-list-row>
              <base-customer-alternative-offers-headline
                title="inquiry.alternativeOffers"
                icon="fa-circle-exclamation"
              ></base-customer-alternative-offers-headline>
            </ng-container>

            <div
              class="position-relative"
              *ngFor="let offer of filteredOffers; let first = first"
            >
              <span
                *ngIf="offer.data.profile.isDirectlyInquired"
                class="directly-inquired-label-customer"
              >
                {{ 'inquiry.directlyInquired' | translate }}
              </span>
              <div
                class="listview-item mb-4"
                [ngClass]="{
                  'offer-sent': offer.data.status === offerStatuses.open,
                  'offer-declined': offer.data.status === offerStatuses.declined,
                  'offer-confirmed': offer.data.status === offerStatuses.confirmed,
                  'offer-needs-confirmation':
                    offer.data.status === offerStatuses.needsConfirmation ||
                    offer.data.status === offerStatuses.needsUpdate,
                  'offer-preselected':
                    isOfferPreselectionAllowed &&
                    offer.data.status === offerStatuses.open &&
                    offer.data.preselected &&
                    !offer.data.workCouncilStatus,
                  'offer-work-council-approved':
                    offer.data.workCouncilStatus === offerWorkCouncilStatuses.APPROVED ||
                    offer.data.workCouncilStatus === offerWorkCouncilStatuses.AUTO_APPROVED,
                  'offer-work-council-disapproved':
                    offer.data.workCouncilStatus === offerWorkCouncilStatuses.DISAPPROVED
                }"
              >
                <base-customer-inquiry-unlimited-offer
                  class="row"
                  [offer]="offer"
                  [inquiry]="inquiry"
                  [assignmentInfo]="assignmentInfo"
                  [validContract]="validContract"
                  [locationWorkCouncilSettings]="locationWorkCouncilSettings"
                ></base-customer-inquiry-unlimited-offer>
              </div>
              <base-customer-alternative-offers-headline
                *ngIf="!!inquiry.directlyInquired && hasDirectlyInquiredOffers && offers.length > 1 && first"
                title="inquiry.alternativeOffers"
                icon="fa-circle-exclamation"
              ></base-customer-alternative-offers-headline>
            </div>
          </div>
        </base-infinite-scroll>
        <base-empty-list-row
          *ngIf="!offers.length"
          class="mt-3"
          message="dashboardInfo.noOffers"
        ></base-empty-list-row>
      </div>
    </div>
    <div class="right-content">
      <base-inquiry-details-sidebar
        [inquiry]="inquiry"
        [inquiryId]="copiedInquiry.id"
        [offersCount]="offersCount"
        [shiftTimes]="shiftTimes"
        [isSidebarVisible]="isSidebarVisible"
        (hideSidebar)="toggleSidebar()"
        [widgetsTemplate]="footerTemplate"
      ></base-inquiry-details-sidebar>
    </div>
  </div>
</div>

<ng-template #footerTemplate>
  <div
    class="d-flex align-items-center right-content gap-3 h-100"
    [ngClass]="inquiry?.status !== baseInquiryStatus.closed ? 'justify-content-end' : 'justify-content-between'"
  >
    <base-action-dropdown
      *ngIf="
        inquiry && (canPublishInquiry || (hasCloseInquiryPermission && inquiry.status !== baseInquiryStatus.closed));
        else inquiryStatus
      "
      class="mw-100"
      [items]="inquiryActions"
      [label]="'states.' + baseInquiryStatusValue[inquiry.status]"
      [color]="inquiry.status === baseInquiryStatus.closed ? 'outline-blue' : 'outline-success'"
      (listItemClicked)="handleClick($event)"
    ></base-action-dropdown>
    <ng-template #inquiryStatus>
      <p
        *ngIf="inquiry"
        baseTruncate
        class="fw-bold d-inline-block text-success mb-0 me-3"
        [ngClass]="{
          'inquiry-closed-state': inquiry.status === baseInquiryStatus.closed,
          'text-success': inquiry.status === baseInquiryStatus.published
        }"
      >
        {{ 'states.' + baseInquiryStatusValue[inquiry.status] | translate | uppercase }}
      </p>
    </ng-template>
    <div
      *ngIf="inquiry && inquiry.status === this.baseInquiryStatus.closed"
      class="reason-info"
    >
      <p
        *ngIf="inquiry.closedBy; else closedBySystemMessage"
        [baseDynamicFontSize]="100"
        class="mb-0 me-3 text-center"
      >
        <ng-container *ngIf="inquiry.closedNote; else noClosingReasonSpecified">
          {{ 'operations.reason' | translate }}: {{ inquiry.closedNote }}
        </ng-container>
        <ng-template #noClosingReasonSpecified>
          <span>{{ 'inquiry.closeInquiry.closedWithoutReason' | translate }}</span>
        </ng-template>
      </p>
      <ng-template #closedBySystemMessage>
        <p class="mb-0 me-3 text-center">{{ 'inquiry.closedBySystem' | translate }}</p>
      </ng-template>
    </div>
    <div class="d-flex gap-2">
      <base-button
        *ngIf="!!inquiry?.directlyInquired"
        [ngbTooltip]="directInquiryTooltip"
        color="dark"
        icon="fa-solid fa-user"
        iconClass="pe-1"
        [iconSize]="buttonSizes.md"
      ></base-button>
      <base-button
        [ngbTooltip]="'inquiry.createByCopy' | translate"
        color="dark"
        icon="fa-solid fa-copy"
        [iconSize]="buttonSizes.md"
        stateClass="pe-1"
        (btnClick)="copyInquiry()"
      ></base-button>
      <base-button
        *ngIf="!inquiry?.directlyInquired"
        [ngbTooltip]="'inquiry.inquiryRecipientsTooltip' | translate"
        color="dark"
        icon="fa-solid fa-split"
        iconClass="pe-1"
        [iconSize]="buttonSizes.md"
        (btnClick)="openInquiredServiceProvidersModal($event)"
      ></base-button>
    </div>
  </div>
</ng-template>

<ng-template #staffRequest>
  <base-customer-staff-request-modal
    [modalRef]="staffRequestModalRef"
    [inquiry]="copiedInquiry"
    [copiedInquiryId]="inquiry?.id"
    [isInquiryDefaultFilter]="true"
  ></base-customer-staff-request-modal>
</ng-template>

<ng-template #closeInquiryModal>
  <base-customer-close-inquiry-form [modalRef]="onInquiryCloseModalRef"></base-customer-close-inquiry-form>
</ng-template>

<ng-template #directInquiryTooltip>
  <base-direct-inquiry-tooltip
    [profileName]="
      inquiry?.directlyInquired
        ? (inquiry?.directlyInquired?.profile?.firstName ?? '') +
          ' ' +
          (inquiry?.directlyInquired?.profile?.lastName ?? '')
        : ''
    "
    [branchName]="inquiry?.directlyInquired?.branch?.name || ''"
  ></base-direct-inquiry-tooltip>
</ng-template>

<ng-template #inquiredServiceProvidersModal>
  <base-customer-inquired-service-providers-modal
    [isInquiryClosed]="inquiry?.status === baseInquiryStatus.closed"
    [inquiryClosingDate]="inquiry?.closed"
    [inquiryId]="inquiry?.id || -1"
  ></base-customer-inquired-service-providers-modal>
</ng-template>
